import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function Knowledge() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data));
  }, []);

  return (
    <div className="py-20 md:py-28 px-6 md:px-10 max-w-7xl mx-auto" data-testid="knowledge-page">
      <div className="overline mb-4">Knowledge Center</div>
      <h1 className="font-serif text-4xl md:text-5xl tracking-tight">Education, insight, and spiritual guidance.</h1>
      <p className="mt-6 text-white/70 max-w-2xl text-lg">
        Articles, FAQs, and community education to support your spiritual path — written by The Lion Chief and the Lyon's Den team.
      </p>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="articles-grid">
        {articles.map((a) => (
          <Link key={a.id} to={`/knowledge/${a.slug}`} className="group bg-[#0A0A0A] border border-white/5 hover:border-[#D4AF37]/40 transition-colors flex flex-col" data-testid={`article-card-${a.slug}`}>
            {a.image_url && (
              <div className="aspect-[16/10] overflow-hidden bg-[#111]">
                <img src={a.image_url} alt={a.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
            )}
            <div className="p-6 flex-1 flex flex-col">
              <div className="overline text-[#D4AF37]">{a.category}</div>
              <h3 className="font-serif text-xl mt-2">{a.title}</h3>
              <p className="text-sm text-white/60 mt-3 leading-relaxed flex-1">{a.excerpt}</p>
              <div className="mt-5 text-xs uppercase tracking-[0.2em] text-[#D4AF37]">Read article →</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
